import React, { Component } from 'react';
import BasicLayout from '../components/layout/BasicLayout';
import { API_AUTH } from '../config';
import { Button, Divider, Input, message, Modal, Popconfirm, Select, Table, Tabs } from 'antd';
import { debounce } from 'lodash';
import { withTranslation } from 'react-i18next';
import { getNetwork } from '../utils/getNetwork';

class RolesPage extends Component {
  constructor() {
    super();
    this.state = {
      rolesMain: [],
      roles: [],
      accesses: [],
      roleEditData: [],
      cases: [],
      defaultCases: [],
      showModal: false,
      modalInputValue: '',
      selectedRow: {},
      menuCurrent: 'updateCase',
      checkedTabs: [],
      checkedSubTabs: [],
      tabsOptionList: [],
      subTabsOptionList: [],
      roleChange: [],
      caseChange: [],
      showAdd: false,
      showAddModal: false,
      showAddUpdateModal: false,
      showAddCaseModal: false,
      code: '',
      description: '',
      codeCase: '',
      descriptionCase: '',
      caseCode: '',
      caseDescription: '',
      selectedCaseIds: [],
      editCaseIds: [],
      editCaseLinks: [],
    };
    this.getData = this.getData.bind(this);
    this.modalHandleOk = this.modalHandleOk.bind(this);
    this.modalHandleCancel = this.modalHandleCancel.bind(this);
    this.modalChangeRoleHandleOk = this.modalChangeRoleHandleOk.bind(this);
    this.modalAddingHandleCancel = this.modalAddingHandleCancel.bind(this);
    this.modalCaseHandleCancel = this.modalCaseHandleCancel.bind(this);
    this.openModal = this.openModal.bind(this);
    this.openAddUpdateCaseModal = this.openAddUpdateCaseModal.bind(this);
    this.openAddCaseModal = this.openAddCaseModal.bind(this);
    this.addCaseModalHandleCancel = this.addCaseModalHandleCancel.bind(this);
    this.checkAddCaseInput = this.checkAddCaseInput.bind(this);
    this.addCase = this.addCase.bind(this);
    this.handleChangeCase = this.handleChangeCase.bind(this);
    this.handleChangeModules = this.handleChangeModules.bind(this);
    this.handleChangeEditModules = this.handleChangeEditModules.bind(this);
    this.assignModulesToNewRole = this.assignModulesToNewRole.bind(this);
    this.syncRoleModules = this.syncRoleModules.bind(this);
    this.handleOpenChange = this.handleOpenChange.bind(this);
    this.handleChangeRole = this.handleChangeRole.bind(this);
    this.changeRoleInputValue = this.changeRoleInputValue.bind(this);
    this.changeCaseInputValue = this.changeCaseInputValue.bind(this);
    this.changeInputValue = this.changeInputValue.bind(this);
    this.checkCaseInput = this.checkCaseInput.bind(this);
    this.checkAddRoleInput = this.checkAddRoleInput.bind(this);
    this.callback = this.callback.bind(this);
  }

  componentDidMount() {
    this.getData();
    // this.parseTabs();
  }

  getData() {
    getNetwork().get(API_AUTH + '/get/roles').then((response) => {
      let rolesMain = response.data;
      this.setState({ rolesMain });
    });
    getNetwork().get(API_AUTH + '/get/roleCases').then((response) => {
      let roles = response.data;
      this.setState({ roles });
    });
    getNetwork().get(API_AUTH + '/get/cases').then((response) => {
      let casesResponse = response.data;
      this.setState({
        cases: casesResponse,
      });
    });
    getNetwork().get(API_AUTH + '/get/access-rights').then((response) => {
      let accessMas = response.data;
      this.setState({
        accesses: accessMas,
      });
    });
  }

  confirmDelete(value) {
    let { t } = this.props;
    const { rolesMain } = this.state;
    let payloadRole;

    rolesMain.map((e) => {
      if (e.code == value.code) {
        payloadRole = e;
      }
    });

    getNetwork()
      .post(API_AUTH + '/delete/roleCases', JSON.stringify(payloadRole), {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(() => {
        message.success(t('settingUpRoles.savedBy'));
        this.getData();
      });
    getNetwork().post(API_AUTH + '/delete/role', JSON.stringify(payloadRole), {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  fetchData = debounce(() => {
    let { t } = this.props;
    this.getData();
    message.success(t('settingUpRoles.savedBy'));
  }, 500);

  modalHandleOk() {
    let { t } = this.props;
    let { menuCurrent, caseChange } = this.state;
    if (menuCurrent === 'updateCase') {
      getNetwork()
        .put(API_AUTH + '/edit/case', JSON.stringify(caseChange), {
          headers: { 'Content-Type': 'application/json' },
        })
        .then(() => {
          message.success(t('settingUpRoles.savedBy'));
          this.getData();
        });
    }
    if (menuCurrent === 'deleteCase') {
      getNetwork()
        .post(API_AUTH + '/delete/case', JSON.stringify(caseChange), {
          headers: { 'Content-Type': 'application/json' },
        })
        .then(() => {
          message.success(t('settingUpRoles.savedBy'));
          this.getData();
        });
    }
    if (menuCurrent === 'addCase') {
      getNetwork()
        .post(API_AUTH + '/add/case', JSON.stringify(caseChange), {
          headers: { 'Content-Type': 'application/json' },
        })
        .then(() => {
          message.success(t('settingUpRoles.savedBy'));
          this.getData();
        });
    }
  }

  checkAddRoleInput() {
    let { t } = this.props;
    let { code, description, roles } = this.state;
    code = code.trim();
    if (code && description) {
      let bool = !roles.some((role) => role.code.trim() === code);

      if (bool) {
        this.addRole();
      } else {
        message.warning(
          t('settingUpRoles.thisUserAlreadyExistsPleaseEnterAnother'),
        );
      }
    } else {
      message.error(t('settingUpRoles.pleaseFillInAllFields'));
    }
  }

  modalChangeRoleHandleOk() {
    let { t } = this.props;

    const payload = {
      accessRights: this.state.roleChange.accessRights,
      code: this.state.roleChange.code,
      description: this.state.roleChange.description,
      id: this.state.roleChange.id,
    };

    getNetwork()
      .put(API_AUTH + '/edit/role', JSON.stringify(payload), {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(() =>
        this.syncRoleModules(
          this.state.roleChange.id,
          this.state.editCaseIds,
          this.state.editCaseLinks,
        ),
      )
      .then(() => {
        message.success(t('settingUpRoles.savedBy'));
        this.getData();
      });
  }

  // Сопоставляет выбранные модули (cases) роли с уже привязанными:
  // добавляет недостающие через /add/casesroles, удаляет лишние через /delete/casesroles/{id}.
  syncRoleModules(roleId, selectedCaseIds, existingLinks) {
    const header = { headers: { 'Content-Type': 'application/json' } };
    const selected = selectedCaseIds || [];
    const links = existingLinks || [];
    const existingCaseIds = links.map((link) => link.caseId);

    const toAdd = selected.filter((id) => !existingCaseIds.includes(id));
    const toRemove = links.filter((link) => !selected.includes(link.caseId));

    const requests = [
      ...toAdd.map((caseId) =>
        getNetwork().post(
          API_AUTH + '/add/casesroles',
          JSON.stringify({ role_id: roleId, case_id: caseId }),
          header,
        ),
      ),
      ...toRemove.map((link) =>
        getNetwork().post(API_AUTH + '/delete/casesroles/' + link.linkId),
      ),
    ];

    return Promise.all(requests).catch(() => {
      message.warning(this.props.t('settingUpRoles.addModuleError'));
    });
  }

  handleChangeModules(value) {
    this.setState({ selectedCaseIds: value });
  }

  handleChangeEditModules(value) {
    this.setState({ editCaseIds: value });
  }

  changeRoleInputValue(e, key) {
    const role = { ...this.state.roleChange, [key]: e.target.value };
    this.setState({
      roleChange: role,
    });
  }

  checkCaseInput() {
    let { t } = this.props;
    let { code, description, cases, caseChange } = this.state;
    code = code.trim();
    if ((code && description) || (caseChange.code && caseChange.description)) {
      let bool = !cases.some((cas) => cas.code.trim() === code);
      if (bool) {
        this.modalHandleOk();
      } else {
        message.warning(
          t('settingUpRoles.thisUserAlreadyExistsPleaseEnterAnother'),
        );
      }
    } else {
      message.error(t('settingUpRoles.pleaseFillInAllFields'));
    }
  }

  changeCaseInputValue(e, key) {
    const cas = { ...this.state.caseChange, [key]: e.target.value };
    this.setState({
      caseChange: cas,
    });
    // this.handleTableUser();
  }

  changeInputValue(e, key) {
    this.setState({
      [key]: e.target.value,
    });
  }

  modalHandleCancel() {
    this.setState({
      showModal: false,
    });
  }

  modalAddingHandleCancel() {
    this.setState({
      showAddModal: false,
    });
  }

  modalCaseHandleCancel() {
    this.setState({
      showAddUpdateModal: false,
    });
  }

  callback(e) {
    this.setState({
      menuCurrent: e,
      caseChange: { code: '', description: '' },
    });
  }

  handleOpenChange(val) {
    this.setState({ showAdd: val });
  }

  handleChangeRole(value) {
    const selectedCases = this.state.accesses.filter((e) =>
      value.includes(e.name),
    );

    this.setState((prevState) => ({
      roleChange: {
        ...prevState.roleChange,
        accessRights: selectedCases,
      },
    }));
  }

  handleChangeCase(value) {
    const selectedCases = this.state.accesses.filter((e) =>
      value.includes(e.name),
    );

    this.setState({
      caseChange: selectedCases,
    });
  }

  addRole() {
    let { t } = this.props;
    let payload = {
      code: this.state.code,
      description: this.state.description,
      accessRights: this.state.caseChange,
    };
    let header = { headers: { 'Content-Type': 'application/json' } };
    getNetwork()
      .post(API_AUTH + '/add/role', JSON.stringify(payload), header)
      .then(() =>
        this.assignModulesToNewRole(this.state.code, this.state.selectedCaseIds),
      )
      .then(() => {
        message.success(t('settingUpRoles.addedBy'));
        this.getData();
        this.setState({
          showAdd: false,
          showAddModal: false,
          selectedCaseIds: [],
          caseChange: [],
        });
      })
      .catch((error) => {
        const code = error && error.data && error.data.code;
        if (code === 'M.ERROR.11') {
          message.error(t('error.duplicateRoleName'));
        } else {
          message.error(t('error.createRole'));
        }
      });
  }

  // После создания роли (POST /add/role не возвращает id) находим её по code
  // и привязываем выбранные модули через /add/casesroles.
  assignModulesToNewRole(code, caseIds) {
    if (!caseIds || caseIds.length === 0) {
      return Promise.resolve();
    }
    const header = { headers: { 'Content-Type': 'application/json' } };
    return getNetwork()
      .get(API_AUTH + '/get/roles')
      .then((response) => {
        const created = (response.data || []).find(
          (role) => role.code && role.code.trim() === code.trim(),
        );
        if (!created) {
          return null;
        }
        return Promise.all(
          caseIds.map((caseId) =>
            getNetwork().post(
              API_AUTH + '/add/casesroles',
              JSON.stringify({ role_id: created.id, case_id: caseId }),
              header,
            ),
          ),
        );
      })
      .catch(() => {
        message.warning(this.props.t('settingUpRoles.addModuleError'));
      });
  }

  openModal(record) {
    this.setState({
      showModal: true,
      selected: record,
      roleChange: {
        code: record.code,
        description: record.description,
        accessRights: record.accessRights,
        id: record.id,
      },
      editCaseIds: [],
      editCaseLinks: [],
    });

    getNetwork()
      .get(API_AUTH + '/get/casesroles/' + record.id)
      .then((response) => {
        const links = (response.data || []).map((caseRole) => ({
          linkId: caseRole.id,
          caseId: caseRole.casesEntity && caseRole.casesEntity.id,
        }));
        this.setState({
          editCaseLinks: links,
          editCaseIds: links.map((link) => link.caseId),
        });
      });
  }

  openAddModal() {
    this.setState({
      showAddModal: true,
      roleChange: { code: '', description: '' },
      code: '',
      description: '',
      caseChange: [],
      selectedCaseIds: [],
    });
  }

  openAddUpdateCaseModal() {
    this.setState({
      showAddUpdateModal: true,
    });
  }

  openAddCaseModal() {
    this.setState({
      showAddCaseModal: true,
      caseCode: '',
      caseDescription: '',
    });
  }

  addCaseModalHandleCancel() {
    this.setState({
      showAddCaseModal: false,
    });
  }

  checkAddCaseInput() {
    let { t } = this.props;
    const { cases } = this.state;
    const code = this.state.caseCode.trim();
    const description = this.state.caseDescription.trim();

    if (!code || !description) {
      message.error(t('settingUpRoles.pleaseFillInAllFields'));
      return;
    }

    const isDuplicate = cases.some((cas) => cas.code.trim() === code);
    if (isDuplicate) {
      message.warning(t('settingUpRoles.moduleAlreadyExists'));
      return;
    }

    this.addCase();
  }

  addCase() {
    let { t } = this.props;
    const payload = {
      code: this.state.caseCode.trim(),
      description: this.state.caseDescription.trim(),
    };

    getNetwork()
      .post(API_AUTH + '/add/case', JSON.stringify(payload), {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(() => {
        message.success(t('settingUpRoles.addedBy'));
        this.getData();
        this.setState({
          showAddCaseModal: false,
          caseCode: '',
          caseDescription: '',
        });
      })
      .catch(() => {
        message.error(t('settingUpRoles.addModuleError'));
      });
  }


  render() {
    let { t } = this.props;
    const columns = [
      {
        title: t('settingUpRoles.code'),
        dataIndex: 'code',
        key: 'code',
      },
      {
        title: t('settingUpRoles.naming'),
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: t('settingUpRoles.roles'),
        dataIndex: 'accessRights',
        key: 'accessRights',
        render: (text, record) => {
          return (
            <span>{record.accessRights.map((e) => e.name).join(', ')}</span>
          );
        },
      },
      {
        title: t('settingUpRoles.modules'),
        key: 'modules',
        render: (text, record) => {
          const roleWithCases = this.state.roles.find(
            (role) => role.id === record.id,
          );
          const cases = (roleWithCases && roleWithCases.cases) || [];
          return <span>{cases.map((c) => c.description).join(', ')}</span>;
        },
      },
      {
        title: t('settingUpRoles.action'),
        key: 'action',
        render: (text, record) => (
          <span>
            <span className="link" onClick={() => this.openModal(record)}>
              {t('settingUpRoles.edit')}
            </span>
            <Divider type="vertical" />
            <Popconfirm
              title="Точно хотите удалить?"
              onConfirm={() => this.confirmDelete(record)}
              okText="Да"
              cancelText="Нет"
            >
              <a href="#"> {t('settingUpRoles.delete')}</a>
            </Popconfirm>
          </span>
        ),
      },
    ];
    const config = {
      pagination: {
        pageSizeOptions: ['10', '20', '30', '60', '80', '100'],
        showSizeChanger: true,
        defaultPageSize: 30,
      },
    };

    return (
      <BasicLayout>
        <h3> {t('configuringUsers.roles')}</h3>
        <div className="roles-actions">
          <Button
            type="primary"
            onClick={() => this.openAddCaseModal()}
          >
            {t('settingUpRoles.addModule')}
          </Button>
          <Button
            type="primary"
            onClick={() => this.openAddModal()}
          >
            {t('settingUpRoles.addRole')}
          </Button>
        </div>
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          dataSource={this.state.rolesMain}
          {...config}
        />
        <Modal
          title={t('settingUpRoles.editRoles')}
          visible={this.state.showModal}
          onOk={this.modalChangeRoleHandleOk}
          onCancel={this.modalHandleCancel}
        >
          <div>
            <div style={{ marginBottom: '10px' }}>
              <Input
                placeholder={t('settingUpRoles.code')}
                value={this.state.roleChange.code}
                onChange={(e) => this.changeRoleInputValue(e, 'code')}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <Input
                placeholder={t('settingUpRoles.naming')}
                value={this.state.roleChange.description}
                onChange={(e) => this.changeRoleInputValue(e, 'description')}
              />
            </div>
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%' }}
              placeholder={t('settingUpRoles.roles')}
              key="description"
              onChange={this.handleChangeRole}
              value={this.state.roleChange.accessRights && this.state.roleChange.accessRights.map(item => item.name)}
            >
              {this.state.accesses.map((e) => (
                <Select.Option key={e.id} value={e.name}>
                  {e.name}
                </Select.Option>
              ))}
            </Select>
            <Select
              mode="multiple"
              allowClear
              showSearch
              optionFilterProp="children"
              style={{ width: '100%', marginTop: '10px' }}
              placeholder={t('settingUpRoles.modules')}
              key="modules"
              value={this.state.editCaseIds}
              onChange={this.handleChangeEditModules}
              filterOption={(input, option) =>
                (option.children &&
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase())) ||
                null
              }
            >
              {this.state.cases.map((c) => (
                <Select.Option key={c.id} value={c.id}>
                  {c.description}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Modal>
        <Modal
          title={t('settingUpRoles.case')}
          visible={this.state.showAddUpdateModal}
          onOk={this.checkCaseInput}
          onCancel={this.modalCaseHandleCancel}
        >
          <div>
            <Tabs defaultActiveKey="updateCase" onChange={this.callback}>
              <Tabs.TabPane tab={t('settingUpRoles.edit')} key="updateCase">
                <div style={{ marginBottom: '10px' }}>
                  <Select
                    style={{ width: '100%' }}
                    placeholder={t('settingUpRoles.case')}
                    key="description"
                    onChange={this.handleChangeCase}
                    // defaultValue={this.state.defaultCases}
                  >
                    {this.state.cases.map((e) => (
                      <Select.Option key={e.id} value={e.description}>
                        {e.description}
                      </Select.Option>
                    ))}
                  </Select>
                </div>

                <div style={{ marginBottom: '10px' }}>
                  <Input
                    placeholder={t('settingUpRoles.code')}
                    value={this.state.accesses.code}
                    onChange={(e) => this.changeCaseInputValue(e, 'code')}
                  />
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <Input
                    placeholder={t('settingUpRoles.description')}
                    value={this.state.accesses.description}
                    onChange={(e) =>
                      this.changeCaseInputValue(e, 'description')
                    }
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab={t('settingUpRoles.add')} key="addCase">
                <div style={{ marginBottom: '10px' }}>
                  <Input
                    placeholder={t('settingUpRoles.code')}
                    value={this.state.accesses.code}
                    onChange={(e) => this.changeCaseInputValue(e, 'code')}
                  />
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <Input
                    placeholder={t('settingUpRoles.description')}
                    value={this.state.accesses.description}
                    onChange={(e) =>
                      this.changeCaseInputValue(e, 'description')
                    }
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab={t('settingUpRoles.delete')} key="deleteCase">
                <div style={{ marginBottom: '10px' }}>
                  <Select
                    style={{ width: '100%' }}
                    placeholder={t('settingUpRoles.case')}
                    key="description"
                    onChange={this.handleChangeCase}
                    // defaultValue={this.state.defaultCases}
                  >
                    {this.state.cases.map((e) => (
                      <Select.Option key={e.id} value={e.description}>
                        {e.description}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              </Tabs.TabPane>
            </Tabs>
          </div>
        </Modal>
        <Modal
          title={t('settingUpRoles.addRole')}
          visible={this.state.showAddModal}
          onOk={this.checkAddRoleInput}
          onCancel={this.modalAddingHandleCancel}
        >
          <div>
            <div style={{ marginBottom: '10px' }}>
              <Input
                placeholder={t('settingUpRoles.code')}
                value={this.state.code}
                onChange={(e) => this.changeInputValue(e, 'code')}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <Input
                placeholder={t('settingUpRoles.naming')}
                value={this.state.description}
                onChange={(e) => this.changeInputValue(e, 'description')}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <Select
                style={{ width: '100%' }}
                placeholder={t('settingUpRoles.roles')}
                key="description"
                onChange={this.handleChangeCase}
                value={(this.state.caseChange || []).map((c) => c.name)}
                showSearch
                mode="multiple"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children && option.children.toLowerCase().includes(input.toLowerCase()) || null
                }
              >
                {this.state.accesses.map((e) => (
                  <Select.Option key={e.id} value={e.name}>
                    {e.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div style={{ marginBottom: '10px' }}>
              <Select
                style={{ width: '100%' }}
                placeholder={t('settingUpRoles.modules')}
                key="modules"
                value={this.state.selectedCaseIds}
                onChange={this.handleChangeModules}
                showSearch
                mode="multiple"
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option.children &&
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())) ||
                  null
                }
              >
                {this.state.cases.map((c) => (
                  <Select.Option key={c.id} value={c.id}>
                    {c.description}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        </Modal>
        <Modal
          title={t('settingUpRoles.addModule')}
          visible={this.state.showAddCaseModal}
          onOk={this.checkAddCaseInput}
          onCancel={this.addCaseModalHandleCancel}
        >
          <div>
            <div style={{ marginBottom: '10px' }}>
              <Input
                placeholder={t('settingUpRoles.code')}
                value={this.state.caseCode}
                onChange={(e) => this.changeInputValue(e, 'caseCode')}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <Input
                placeholder={t('settingUpRoles.description')}
                value={this.state.caseDescription}
                onChange={(e) => this.changeInputValue(e, 'caseDescription')}
              />
            </div>
          </div>
        </Modal>
      </BasicLayout>
    );
  }
}

export default withTranslation()(RolesPage);
